import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
    hierarchy: {
        maxHeight: '40vh',
        overflow: 'auto',
        "& .MuiTreeItem-root.Mui-selected > .MuiTreeItem-content .MuiTreeItem-label": {
            backgroundColor: 'rgb(255, 245, 205)',
        },
    },
    nodeLabel: {
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing(.5, 0),
    },
    nodeLabelIcon: {
        width: 10,
    },
    nodeLabelName: {
        fontSize: 14,
        fontWeight: 500,
        margin: theme.spacing(0, 4, 0, 1.5)
    },
    nodeLabelCount: {
        backgroundColor: 'rgb(216, 216, 216)',
        fontSize: 10,
    },
    nodeLabelRoot:{

    },
}));
